import { QueryFunctionContext } from "@tanstack/react-query";

import { RequestApplePayPaymentSessionRequest } from "frontend-client";

import { fetchClient } from "./fetch-client";

export const queryKeys = {
  applePaySession: (
    apiHost: string,
    version: string,
    checkoutSessionToken: string,
    validationURL: string,
    hostName: string
  ) =>
    [
      {
        scope: "apple-pay-session",
        apiHost,
        version,
        checkoutSessionToken,
        validationURL,
        hostName,
      },
    ] as const,
};

export const fetchApplePaySession = ({
  queryKey: [
    { apiHost, version, checkoutSessionToken, validationURL, hostName },
  ],
}: QueryFunctionContext<ReturnType<(typeof queryKeys)["applePaySession"]>>) => {
  const request = new RequestApplePayPaymentSessionRequest();
  request.validationUrl = validationURL;
  request.merchantDomain = hostName;

  return fetchClient({ apiHost, version }).requestApplePayPaymentSession(
    request,
    {
      headers: {
        Authorization: "Bearer " + checkoutSessionToken,
      },
    }
  );
};
